import { Component, OnInit, OnDestroy, ChangeDetectionStrategy, inject } from '@angular/core';
import {AppComponent} from './app.component';
import {AppMainComponent} from './app.main.component';
import {Subscription} from 'rxjs';
import { ConfigService } from './app.config.service';
import {AppConfig} from './appconfig';

@Component({
    selector: 'app-config',
    template: `
        <div class="layout-config" [ngClass]="{'layout-config-active': appMain.configActive}" (click)="appMain.onConfigClick($event)">
          <a style="cursor: pointer" id="layout-config-button" class="layout-config-button" (click)="onConfigButtonClick($event)">
            <i class="pi pi-cog"></i>
          </a>
          <a style="cursor: pointer" class="layout-config-close" (click)="onConfigCloseClick($event)">
            <i class="pi pi-times"></i>
          </a>
          <div class="layout-config-content">
            <div class="px-3 pt-3">
              <h5>Theme Customization</h5>
              <span>Serenity offers different themes for layout, topbar, menu etc.</span>
            </div>
        
            <hr class="mb-0" />
        
            <div class="layout-config-options p-3">
              <h6 class="mt-0">Layout Color Mode</h6>
              <div class="formgroup-inline">
                <div class="field-radiobutton">
                  <p-radiobutton name="layoutColor" value="dark" [(ngModel)]="app.layoutColor" inputId="layoutColor1" (onClick)="onLayoutColorChange($event, 'dark')"></p-radiobutton>
                  <label for="layoutColor">Dark</label>
                </div>
                <div class="field-radiobutton">
                  <p-radiobutton name="layoutColor" value="light" [(ngModel)]="app.layoutColor" inputId="layoutColor2" (onClick)="onLayoutColorChange($event, 'light')"></p-radiobutton>
                  <label for="layoutColor2">Light</label>
                </div>
              </div>
        
              <h6 class="mt-0">Menu Mode</h6>
              <div class="formgroup-inline">
                <div class="field-radiobutton">
                  @if (app.layoutMode !== 'static') {
                    <p-radiobutton name="layoutMode" value="overlay" [(ngModel)]="app.layoutMode" inputId="mode1"></p-radiobutton>
                  }
                  @if (app.layoutMode === 'static') {
                    <p-radiobutton name="layoutMode" value="static" [(ngModel)]="app.layoutMode" inputId="mode1"></p-radiobutton>
                  }
                  <label for="mode1">Vertical</label>
                </div>
                <div class="field-radiobutton">
                  <p-radiobutton name="layoutMode" value="horizontal" [(ngModel)]="app.layoutMode" inputId="mode2"></p-radiobutton>
                  <label for="mode2">Horizontal</label>
                </div>
              </div>
        
              <h6 class="mt-0">Menu Color Mode</h6>
              <div class="formgroup-inline">
                <div class="field-radiobutton">
                  <p-radiobutton name="darkMenu" [value]="true" [(ngModel)]="app.darkMenu" inputId="darkMenu1"
                  [disabled]="app.layoutColor === 'dark'" [style]="{'cursor': app.layoutColor === 'dark' ? 'default' : 'pointer'}"></p-radiobutton>
                  <label for="darkMenu1">Dark</label>
                </div>
                <div class="field-radiobutton">
                  <p-radiobutton name="darkMenu" [value]="false" [(ngModel)]="app.darkMenu" inputId="darkMenu2"
                  [disabled]="app.layoutColor === 'dark'" [style]="{'cursor': app.layoutColor === 'dark' ? 'default' : 'pointer'}"></p-radiobutton>
                  <label for="darkMenu2">Light</label>
                </div>
              </div>
        
              <h6 class="mt-0">Orientation</h6>
              <div class="formgroup-inline">
                <div class="field-radiobutton">
                  <p-radiobutton name="isRTL" [value]="false" [(ngModel)]="app.isRTL" inputId="isRTL1"></p-radiobutton>
                  <label for="isRTL1">LTR</label>
                </div>
                <div class="field-radiobutton">
                  <p-radiobutton name="isRTL" [value]="true" [(ngModel)]="app.isRTL" inputId="isRTL2"></p-radiobutton>
                  <label for="isRTL2">RTL</label>
                </div>
              </div>
        
              <h6 class="mt-0">Input Style</h6>
              <div class="formgroup-inline">
                <div class="field-radiobutton">
                  <p-radiobutton name="inputStyle" value="outlined" [(ngModel)]="app.inputStyle"
                  inputId="inputStyle1"></p-radiobutton>
                  <label for="inputStyle1">Outlined</label>
                </div>
                <div class="field-radiobutton">
                  <p-radiobutton name="inputStyle" value="filled" [(ngModel)]="app.inputStyle" inputId="inputStyle2"></p-radiobutton>
                  <label for="inputStyle2">Filled</label>
                </div>
              </div>
        
              <h6 class="mt-0">Ripple Effect</h6>
              <p-toggleswitch [ngModel]="app.ripple" (onChange)="appMain.onRippleChange($event)"></p-toggleswitch>

              <h6>Polling</h6>
              <div class="field-checkbox">
                <p-toggleswitch [ngModel]="pollingDisabled" (onChange)="onPollingDisabledChange($event)"></p-toggleswitch>
                <label class="ml-2">Vypnúť polling semafóru</label>
              </div>

              <h6>Flat Layouts</h6>
              <div class="layout-themes">
                @for (flatLayout of flatLayoutColors; track flatLayout) {
                  <div>
                    <a style="cursor: pointer" class="flat-layouts" (click)="changeLayout(flatLayout.label)"
                      [ngStyle]="{'background-color': flatLayout.color}">
                      @if (layout === flatLayout.label) {
                        <i class="pi pi-check"></i>
                      }
                    </a>
                  </div>
                }
              </div>
        
              <h6>Special Layouts</h6>
              <div class="layout-themes">
                @for (specialLayout of specialLayoutColors; track specialLayout) {
                  <div>
                    <a style="cursor: pointer" (click)="changeLayout(specialLayout.label)">
                      <img src="assets/layout/images/configurator/layout/special/{{specialLayout.image}}.png"
                        [alt]="specialLayout.label"/>
                        @if (layout === specialLayout.label) {
                          <i class="pi pi-check"></i>
                        }
                      </a>
                    </div>
                  }
                </div>
        
              </div>
            </div>
          </div>
        `,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AppConfigComponent implements OnInit, OnDestroy {
    app = inject(AppComponent);
    appMain = inject(AppMainComponent);
    configService = inject(ConfigService);


    layout = 'deeppurple';

    flatLayoutColors: any[];

    specialLayoutColors: any[];

    config: AppConfig;

    pollingDisabled = false;

    subscription: Subscription;

    ngOnInit() {
        this.config = this.configService.config;
        this.pollingDisabled = !!this.config.pollingDisabled;
        this.subscription = this.configService.configUpdate$.subscribe(config => {
            this.config = config;
            this.pollingDisabled = !!config.pollingDisabled;
        });

        this.flatLayoutColors = [
            {name: 'Amber Pink', label: 'amber', color: '#FFB300'},
            {name: 'Blue Amber', label: 'blue', color: '#1E88E5'},
            {name: 'Blue Grey Green', label: 'bluegrey', color: '#607D8B'},
            {name: 'Brown Cyan', label: 'brown', color: '#795548'},
            {name: 'Cyan Amber', label: 'cyan', color: '#00BCD4'},
            {name: 'Deep Orange Cyan', label: 'deeporange', color: '#F4511E'},
            {name: 'Deep Purple Orange', label: 'deeppurple', color: '#5E35B1'},
            {name: 'Green Brown', label: 'green', color: '#43A047'},
            {name: 'Grey Indigo', label: 'grey', color: '#757575'},
            {name: 'Indigo Pink', label: 'indigo', color: '#3f51b5'},
            {name: 'Light Blue Blue Grey', label: 'lightblue', color: '#03A9F4'},
            {name: 'Light Green Purple', label: 'lightgreen', color: '#7CB342'},
            {name: 'Lime Blue Grey', label: 'lime', color: '#C0CA33'},
            {name: 'Orange Indigo', label: 'orange', color: '#FB8C00'},
            {name: 'Pink Amber', label: 'pink', color: '#D81B60'},
            {name: 'Purple Pink', label: 'purple', color: '#8E24AA'},
            {name: 'Teal Red', label: 'teal', color: '#009688'},
            {name: 'Yellow Teal', label: 'yellow', color: '#FBC02D'},
        ];
        this.specialLayoutColors = [
            {image: 'reflection', label: 'reflection'},
            {image: 'moody', label: 'moody'},
            {image: 'cityscape', label: 'cityscape'},
            {image: 'cloudy', label: 'cloudy'},
            {image: 'storm', label: 'storm'},
            {image: 'palm', label: 'palm'},
            {image: 'flatiron', label: 'flatiron'}
        ];
    }

    onPollingDisabledChange(event) {
        this.pollingDisabled = event.checked;
        this.configService.updateConfig({...this.config, pollingDisabled: event.checked});
    }

    onLayoutColorChange(event, color) {
        this.app.layoutColor = color;
        this.app.darkMenu = color === 'dark';
        // Aura dark mode is driven by the `.dark` class on <html> (darkModeSelector: '.dark').
        document.documentElement.classList.toggle('dark', color === 'dark');
        this.configService.updateConfig({...this.config, ...{dark: color === 'dark'}});
    }

    changeLayout(layout) {
        this.layout = layout;

        const layoutLink: HTMLLinkElement = document.getElementById('layout-css') as HTMLLinkElement;
        const layoutHref = 'assets/layout/css/layout-' + layout + '.css';
        this.replaceLink(layoutLink, layoutHref);
    }

    replaceLink(linkElement, href) {
        if (this.isIE()) {
            linkElement.setAttribute('href', href);
        } else {
            const id = linkElement.getAttribute('id');
            const cloneLinkElement = linkElement.cloneNode(true);

            cloneLinkElement.setAttribute('href', href);
            cloneLinkElement.setAttribute('id', id + '-clone');

            linkElement.parentNode.insertBefore(cloneLinkElement, linkElement.nextSibling);

            cloneLinkElement.addEventListener('load', () => {
                linkElement.remove();
                cloneLinkElement.setAttribute('id', id);
            });
        }
    }

    onConfigButtonClick(event) {
        this.appMain.configActive = !this.appMain.configActive;
        event.preventDefault();
    }

    onConfigCloseClick(event) {
        this.appMain.configActive = false;
        event.preventDefault();
    }

    isIE() {
        return /(MSIE|Trident\/|Edge\/)/i.test(window.navigator.userAgent);
    }

    ngOnDestroy(){
        if(this.subscription){
            this.subscription.unsubscribe();
        }
    }
}
